export const BLOGS = [
  {
    id: "blog-001",
    slug: "rise-of-agentic-ai",
    title: "The Rise of Agentic AI: Beyond Simple Chatbots",
    excerpt:
      "Agentic systems represent a fundamental shift from reactive AI to proactive AI - machines that plan, execute, and adapt in real-world workflows without constant human oversight.",
    category: "Agentic Systems",
    tags: ["AI Agents", "LLM", "Enterprise", "Autonomy"],
    read_time: 14,
    image_url: "/images/blogs/blog-agentic-ai.svg",
    status: "published",
    published_at: "2026-02-12T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-002",
    slug: "production-voice-agents-architecture",
    title: "Building Production Voice Agents: Architecture Deep Dive",
    excerpt:
      "From acoustic model selection to latency optimization - a comprehensive look at what it takes to ship a voice agent that handles 10,000 concurrent calls reliably.",
    category: "Voice AI",
    tags: ["Voice Agents", "Architecture", "Production", "Latency"],
    read_time: 14,
    image_url: "/images/blogs/blog-voice-arch.svg",
    status: "published",
    published_at: "2026-02-26T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-003",
    slug: "ml-system-design-billion-rps",
    title: "ML System Design: From Prototype to 1B Requests/Day",
    excerpt:
      "The gap between a working ML prototype and a production system that serves a billion daily requests is enormous. Here's the design playbook we use at Melonai.",
    category: "ML System Design",
    tags: ["ML Systems", "Scalability", "Infrastructure", "Design"],
    read_time: 16,
    image_url: "/images/blogs/blog-ml-design.svg",
    status: "published",
    published_at: "2026-03-12T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-004",
    slug: "multi-agent-coordination-patterns",
    title: "Multi-Agent Coordination: Patterns and Anti-Patterns",
    excerpt:
      "How do you coordinate five AI agents working on a shared goal without deadlocks, duplication, or divergence? We break down the patterns that work - and the ones that don't.",
    category: "Agentic Systems",
    tags: ["Multi-Agent", "Coordination", "Patterns"],
    read_time: 13,
    image_url: "/images/blogs/blog-multi-agent.svg",
    status: "published",
    published_at: "2026-03-26T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-005",
    slug: "llm-finetuning-domain-specific",
    title: "LLM Fine-tuning for Domain-Specific Applications",
    excerpt:
      "Generic LLMs underperform on vertical tasks. Here's a practical guide to fine-tuning, RLHF, and evaluation strategies for domain-specific deployments.",
    category: "AI Research",
    tags: ["LLM", "Fine-tuning", "RLHF", "Evaluation"],
    read_time: 14,
    image_url: "/images/blogs/blog-llm-finetune.svg",
    status: "published",
    published_at: "2026-04-16T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-006",
    slug: "rag-vs-finetuning",
    title: "RAG vs Fine-tuning: When to Use Which",
    excerpt:
      "The ongoing debate between retrieval-augmented generation and fine-tuning is nuanced. Here's our decision framework for choosing the right approach for your use case.",
    category: "AI Research",
    tags: ["RAG", "Fine-tuning", "LLM", "Decision Framework"],
    read_time: 12,
    image_url: "/images/blogs/blog-rag-vs-finetune.svg",
    status: "published",
    published_at: "2026-05-04T10:00:00+00:00",
    references: [],
  },
  {
    id: "blog-007",
    slug: "journey-of-an-audio-frame-through-stt",
    title: "Journey of a Single Audio Frame Through a Speech-to-Text Model",
    excerpt:
      "Follow 30 milliseconds of sound from the microphone to a word on the screen. Every step inside Whisper-large-v3-turbo explained, with the math behind it.",
    category: "Voice AI",
    tags: ["Speech-to-Text", "Whisper", "Architecture", "Transformers"],
    read_time: 22,
    image_url: "/images/blogs/blog-audio-journey.svg",
    status: "published",
    published_at: "2026-05-19T10:00:00+00:00",
    references: [],
  },
];
